import styled from 'styled-components';
import { variant, typography } from 'styled-system';
import { Text } from './Text.js';

var prefix = "heading";
var Heading = styled(Text)(variant({
    prop: "size",
    variants: {
        xxxl: {
            fontSize: "".concat(prefix, ".xxxl"),
            lineHeight: "".concat(prefix, ".xxxl"),
            letterSpacing: "xs",
        },
        xxl: {
            fontSize: "".concat(prefix, ".xxl"),
            lineHeight: "".concat(prefix, ".xxl"),
            letterSpacing: "xs",
        },
        xl: {
            fontSize: "".concat(prefix, ".xl"),
            lineHeight: "".concat(prefix, ".xl"),
            letterSpacing: "xs",
        },
        lg: {
            fontSize: "".concat(prefix, ".lg"),
            lineHeight: "".concat(prefix, ".lg"),
            letterSpacing: "sm",
        },
        md: {
            fontSize: "".concat(prefix, ".md"),
            lineHeight: "".concat(prefix, ".md"),
            letterSpacing: "sm",
        },
        sm: {
            fontSize: "".concat(prefix, ".sm"),
            lineHeight: "".concat(prefix, ".sm"),
            letterSpacing: "sm",
        },
        xs: {
            fontSize: "".concat(prefix, ".xs"),
            lineHeight: "".concat(prefix, ".xs"),
            letterSpacing: "sm",
        },
        xxs: {
            fontSize: "".concat(prefix, ".xxs"),
            lineHeight: "".concat(prefix, ".xxs"),
            letterSpacing: "sm",
        },
    },
}), variant({
    prop: "weight",
    variants: {
        slim: {
            fontWeight: "".concat(prefix, ".slim"),
        },
        base: {
            fontWeight: "".concat(prefix, ".base"),
        },
        heavy: {
            fontWeight: "".concat(prefix, ".heavy"),
        },
    },
}), typography);
Heading.defaultProps = {
    size: "md",
    weight: "base",
};

export { Heading };
//# sourceMappingURL=Heading.js.map
